type _InviteBody = {
    summary: string,
    vacancy: string,
    startTime: number,
    platform: number,
    location: string,
    description: string,
    message?: string,
    type: number
};

export const useApiResponses = () => {
    return {
        /**
         * Создать отклик от лица текущего пользователя
         * @param id
         */
        add: async (id: string, summaryId?: string) => {
            const response = await mainFetch('responses', {
                method: 'POST',
                body: { vacancy: id, ...(summaryId ? { summary: summaryId } : {}) }
            });

            if (response.error.value === null) {
                DataLayer().push({
                    event: 'response'
                });
            }

            return response;
        },
        invite: (body: _InviteBody, isForce: boolean = false) => {
            body = {
                isInvite: true,
                force: isForce,
                ...body
            };

            return mainFetch('responses', {
                method: 'POST',
                body: body
            });
        },
    };
}
